import AppleHealthChartsWrapper from 'pages/Dashboard/components/AppleHealthChartsWrapper';
import AppleHealthSleepChart from 'pages/Dashboard/components/AppleHealthSleepChart';
import useSleepData from 'pages/Dashboard/useSleepData';
import { getChartDateRanges, TimeFrameOptions } from 'pages/Dashboard/utils/trackingUtils';
import React, { useEffect } from 'react';
import { MixpanelEventName } from 'utils/constants';
import { trackMixpanelEvent } from 'utils/utilMethods';
import AppleHealthSleepDialog from 'pages/Dashboard/components/AppleHealthSleepDialog';
import { ListWaypointDetails } from 'pages/Dashboard/types/waypoints.types';

interface SleepComponentProps {
    timeFrame: TimeFrameOptions;
    waypointId:string;
    patientId:string;
    providerId:string;
    title:string;
    subtitle:string;
    type:string;
    setCardStatus?: (type:string, v: boolean) => void;
    numberOfCards:number;
    setLoading?: (value:boolean) => void
    onChangeTimeFrame: (v: string) => void;
   }

function SleepComponent({
  timeFrame,
  waypointId,
  patientId,
  providerId,
  title,
  subtitle,
  onChangeTimeFrame,
  type,
  setCardStatus,
  numberOfCards,
  setLoading,

} : SleepComponentProps) {
  const {
    averages,
    previousPeriodAverages,
    onChangeSource,
    sourceId,
    sourceOptions,
    isLoading,
    sourceObject,
    fetchPatientWaypointTrackingResult,
    hasData } = useSleepData({
    patientId,
    waypointId,
    providerId,
    timeFrame,
  });
  const yAxisProps = getChartDateRanges(timeFrame as TimeFrameOptions) as {
      startTime: number;
      endTime: number;
      ticks: number[];
      isInDays: boolean;
    };
  const [isDrawerOpen, setIsDrawerOpen] = React.useState('');
  useEffect(() => {
    setLoading?.(isLoading);
  }, [isLoading, setLoading]);
  const closeDrawer = React.useCallback(() => {
    setIsDrawerOpen('');
  }, []);

  const openDrawer = React.useCallback(() => {
    trackMixpanelEvent(
      MixpanelEventName.PATIENT_DETAILS_AH_SLEEP_CHART_VIEW_DETAILS_BUTTON_CLICKED,
      {
        'patient id': patientId ?? '',
        location: 'progress_monitor_tab_sleep_view_details',
      },
      true,
    );
    setIsDrawerOpen('show');
  }, [patientId]);

  useEffect(() => {
    setCardStatus && setCardStatus(type, hasData);
  }, [hasData, setCardStatus, type]);
  return (
    hasData ? (
      <>
        <AppleHealthChartsWrapper
          timeFrame={timeFrame}
          title={title}
          subTitle={subtitle}
          isLoading={isLoading}
          headerIcon='nights_stay'
          gridSize={numberOfCards === 3 ? 4 : 6}
          hasMultipleItems
          showTimeFrame
          sourceObject={sourceObject}
          renderChart={(
            <AppleHealthSleepChart
              timeFrame={timeFrame}
              averages={averages}
              previousPeriodAverages={previousPeriodAverages}
              setSourceId={onChangeSource}
              sourceId={sourceId}
              sourceOptions={sourceOptions}
              openDrawer={openDrawer}
            />
      )}
        />
        <AppleHealthSleepDialog
          isOpen={!!isDrawerOpen}
          onClose={closeDrawer}
          timeFrame={timeFrame}
          yAxisProps={yAxisProps}
          onChangeTimeFrame={onChangeTimeFrame}
          sourceId={sourceId}
          isLoading={isLoading}
          fetchPatientWaypointTrackingResult={fetchPatientWaypointTrackingResult as
             {data:ListWaypointDetails}}
          onChangeSource={onChangeSource}
          sourceOptions={sourceOptions}
        />
      </>
    )
      : null
  );
}

export default SleepComponent;
